module.exports = __webpack_public_path__ + "img/brand-video.eecd0a78.gif";